import { createContext, useReducer } from 'react';
import { toastReducer } from './toastReducer';
import { Toaster } from './Toaster';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ToastContext = /*#__PURE__*/createContext({
  show: () => 0,
  remove: () => {},
  clear: () => {}
});
const initialState = {
  toasts: []
};

/**
 * Allows any component wrapped in the provider to access methods to add and remove toasts.
 * Renders the Toaster component under the hood.
 * @param children - Children that will have access to the context
 * @param autoClose - Whether or not the toasts should automatically close
 * @returns JSX.Element
 */
export const ToastProvider = ({
  children,
  autoClose = true
}) => {
  const [state, dispatch] = useReducer(toastReducer, initialState);
  const show = ({
    variant,
    message
  }) => {
    const id = Math.floor(Math.random() * 10000000);
    dispatch({
      type: 'ADD_TOAST',
      payload: {
        id,
        message,
        variant
      }
    });
    return id;
  };
  const remove = id => {
    dispatch({
      type: 'DELETE_TOAST',
      payload: id
    });
  };
  const clear = () => {
    dispatch({
      type: 'CLEAR_TOASTS'
    });
  };
  const value = {
    show,
    remove,
    clear
  };
  return /*#__PURE__*/_jsxs(ToastContext.Provider, {
    value: value,
    children: [/*#__PURE__*/_jsx(Toaster, {
      toasts: state.toasts,
      autoClose: autoClose
    }), children]
  });
};